import { Me } from "domain/models/me";

import { atom } from "recoil";

export const userState = atom<Me | null>({
  key: "userState",
  default: null,
});
